"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class LikedPostsApiUrlBuilder {
    constructor(wpApiSettings) {
        this.wpApiSettings = wpApiSettings;
    }
    build(likedPosts, appearance, postTypes) {
        let postIds = [];
        for (const postId in likedPosts) {
            if (!postTypes || postTypes.includes(likedPosts[postId].postType)) {
                postIds.push(postId);
            }
        }
        return `${this.wpApiSettings.root}like/v1/ids=${postIds.join(',')}?html&appearance=${appearance}`;
    }
}
exports.default = LikedPostsApiUrlBuilder;
